import * as React from 'react';
import { Box, Typography } from '@mui/material';
import { PATIENT_LIST_VIEW } from 'pages/Dashboard/enums';
import SelectProvider from 'pages/Dashboard/components/SelectProvider';
import { PracticeProvider } from 'pages/Dashboard/types/providers.types';
import Theme from 'theme';
import SearchBar from 'pages/Dashboard/components/SearchBar';

interface TProps {
  statusFilter: string;
  patientsCount: Record<string, number>;
  updateStatusFilter: React.Dispatch<string>;
  providerAssociations: PracticeProvider[];
  providerIdFilter: string;
  setProviderIdFilter: (provider: string) => void;
  debouncedSearchQuery: (query: string) => void;
}

export default function ListPatientFilters({
  statusFilter,
  patientsCount,
  updateStatusFilter,
  providerAssociations,
  providerIdFilter,
  setProviderIdFilter,
  debouncedSearchQuery,
}: TProps) {
  const titleMap = {
    READY: 'Activated',
    PENDING: 'Pending',
  };

  return (
    <Box
      display='flex'
      flexDirection={{ xs: 'column-reverse', md: 'column' }}
      justifyContent='space-between'
      alignItems='center'
      width='100%'
      flexWrap='wrap'
    >
      <Box
        gap={1.5}
        mb={{ xs: 0, md: 1.5 }}
        mt={{ xs: 1.5, md: 0 }}
        display='flex'
        flexDirection='row'
        flexWrap='wrap'
        justifyContent='space-between'
        width='100%'
      >
        <Box flex={1} minWidth={200} maxWidth={{ xs: '100%', md: 550 }}>
          <SearchBar onSearch={debouncedSearchQuery} />
        </Box>
        {providerAssociations.length > 0 && (
          <Box sx={{ display: 'flex', alignItems: 'center', minWidth: { xs: '100%', md: 320 } }}>
            <SelectProvider
              providers={providerAssociations}
              selectedProvider={providerIdFilter}
              setSelectedProvider={setProviderIdFilter}
            />
          </Box>
        )}
      </Box>
      <Box sx={{ display: 'flex', gap: 0 }} width='100%'>
        {Object.values(PATIENT_LIST_VIEW).map((filter) => (
          <Box key={filter} flex={1}>
            <Typography
              variant='subtitle1'
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderBottom: 3,
                paddingBottom: 1,
                pl: 2,
                pr: 2,
                borderBottomColor:
                  statusFilter === filter ? Theme.custom.darkTextPrimary : 'transparent',
                cursor: 'pointer',
                color:
                  statusFilter === filter
                    ? Theme.custom.darkTextPrimary
                    : Theme.custom.colors.lightTextSecondary,
                fontWeight: 500,
                whiteSpace: 'nowrap',
              }}
              onClick={() => updateStatusFilter(filter)}
            >
              {titleMap[filter]}
              {patientsCount[filter] >= 0 && (
                <Box
                  sx={{
                    bgcolor:
                      statusFilter === filter
                        ? Theme.custom.darkTextPrimary
                        : Theme.custom.colors.lightTextSecondary,
                    ml: 0.75,
                    display: 'inline-flex',
                    p: 0.75,
                    borderRadius: 12,
                    minWidth: 24,
                    height: 24,
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <Typography
                    variant='caption'
                    component='p'
                    color='#FFF'
                    sx={{
                      width: '100%',
                      textAlign: 'center',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {patientsCount[filter] || 0}
                  </Typography>
                </Box>
              )}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
